import { AddFormDataActionData } from '../../@types/action';
import { StepData } from '../../@types/step-data';
import Action, { ActionProps } from '../action';
import { isEmpty } from '@s-libs/micro-dash';

interface AddFormDataActionProps extends ActionProps {
  step: AddFormDataActionData;
}

class AddFormDataAction extends Action {
  step: AddFormDataActionData;

  constructor(props: AddFormDataActionProps) {
    super(props);
    this.step = props.step;
  }

  async perform(): Promise<StepData> {
    if (this.conditionsSatisfied() && !isEmpty(this.newFormData)) {
      Object.assign(this.formData, this.newFormData);
    }

    return this.getNextStep();
  }

  get newFormData() {
    return this.step.options;
  }
}

export default AddFormDataAction;
